export default "__VITE_ASSET__6ynd6_pB__"